import CookieConsentPanel from './CookieConsentPanel';

export default CookieConsentPanel;
